import { Observable } from 'rxjs';
import { cloneDeep } from 'lodash';

export interface MultiselectAutocompleteApiModel<T> {
    type: string;
    value: T[];
    headerLabel: string;
    placeholder: string;
    browseAll: boolean;
    isAutocomplete: boolean;
    autocompleteDropdown?: boolean;
    labelLookup?: (keys: any[]) => Observable<any[]>;
    labelLookupKey?: string;
    labelLookupValue?: string;
    labelField?: string;
    suggestionsFetcher?: (searchString: string) => Observable<any[]>;
}

export class MultiselectAutocompleteModel<T = any> {
    type: string;
    value: T[];
    headerLabel: string;
    placeholder: string;
    browseAll: boolean;
    isAutocomplete: boolean;
    autocompleteDropdown?: boolean;
    labelLookup?: (keys: any[]) => Observable<any[]>;
    labelLookupKey?: string;
    labelLookupValue?: string;
    labelField?: string;
    suggestionsFetcher?: (searchString: string) => Observable<any[]>;

    constructor(apiModel?: MultiselectAutocompleteApiModel<T>) {
        if (apiModel) {
            this.constructFromApi(apiModel);
        }
    }

    constructFromApi(apiModel: MultiselectAutocompleteApiModel<T>) {
        this.type = apiModel.type;
        this.value = apiModel.value;
        this.headerLabel = apiModel.headerLabel;
        this.placeholder = apiModel.placeholder;
        this.browseAll = apiModel.browseAll;
        this.isAutocomplete = apiModel.isAutocomplete;
        this.autocompleteDropdown = apiModel.autocompleteDropdown;
        this.labelLookup = apiModel.labelLookup;
        this.labelLookupKey = apiModel.labelLookupKey;
        this.labelLookupValue = apiModel.labelLookupValue;
        this.labelField = apiModel.labelField;
        this.suggestionsFetcher = apiModel.suggestionsFetcher;
    }


    toApiEntity(): MultiselectAutocompleteApiModel<T> {
        const model: MultiselectAutocompleteApiModel<T> = {
            type: this.type,
            value: this.value,
            headerLabel: this.headerLabel,
            placeholder: this.placeholder,
            browseAll: this.browseAll,
            isAutocomplete: this.isAutocomplete,
            autocompleteDropdown: this.autocompleteDropdown,
            labelLookup: this.labelLookup,
            labelLookupKey: this.labelLookupKey,
            labelLookupValue: this.labelLookupValue,
            labelField: this.labelField,
            suggestionsFetcher: this.suggestionsFetcher
        };

        return model;
    }


    clone(): MultiselectAutocompleteModel<T> {
        const clone = new MultiselectAutocompleteModel<T>(this.toApiEntity());

        return cloneDeep(clone);
    }
}
